/*---

  Scripts for the product page

  Louis-Charles Blais [info@22agencecreative.ca]

---*/


// Product page variant switcher
let sectionId = document.querySelector('.product-container').dataset.shopifySectionId;
      
function updateProductSection() {
  let form = event.target.closest('form');
  
  const selectedOptionValues = Array.from(
      form.querySelectorAll('.product-option-value:checked')
    ).map(({value}) => value);

  const params = selectedOptionValues.length > 0
    ? `&option_values=${selectedOptionValues.join(',')}`
    : '';
  
  fetch(window.location.pathname + '?section_id=' + sectionId + params)
  .then((response) => response.text())
  .then((responseText) => {
    const newHtml = new DOMParser().parseFromString(responseText, 'text/html');
    document.querySelector('.product-container').innerHTML = newHtml.querySelector('.product-container').innerHTML;
  });
}

// Image switcher
function switchMainImage() {
  let mainImage = document.querySelector('#main-image');
  mainImage.src = event.target.dataset.mainSrc;
}

// Floating product form bar
let stickyProductForm = document.querySelector('.product .sticky-product-form');
let lastKnownScrollPosition = 0;
let ticking = false;

function handleStickyProductForm(scrollPos) {
  if (scrollPos >= 800) {
    stickyProductForm.classList.add('active');
  } else {
    stickyProductForm.classList.remove('active');
  }
}

document.addEventListener("scroll", (event) => {
  lastKnownScrollPosition = window.scrollY;
  if (!ticking) {
    window.requestAnimationFrame(() => {
      handleStickyProductForm(lastKnownScrollPosition);
      ticking = false;
    });

    ticking = true;
  }
});



